// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_F5x8D","header":"header_Kz8DD","center":"center_taHRL","decoration":"decoration_PHAMV","title":"title_JuEtj","desc":"desc_t-1Y2"};